/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

console.log("Hello World from Webpacker");

// Your progress tracking function:
window.initializeProgressTracking = function (eventId) {
  const progressBar = document.getElementById("progress-bar");
  const progressText = document.getElementById("progress-text");

  if (!progressBar || !progressText) {
    return;
  }

  function updateProgress() {
    fetch(`/events/${eventId}/track_progress`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((data) => {
        const percentage = (data.processed / data.total) * 100 || 0;
        progressBar.style.width = `${percentage}%`;
        progressText.innerHTML = `Processadas <b>${data.processed}</b> de <b>${data.total}</b> credenciais`;

        if (data.processed < data.total) {
          setTimeout(updateProgress, 1000);
        } else {
          progressText.textContent = "Processamento concluído!";
          setTimeout(() => {
            var modal = M.Modal.getInstance(
              document.getElementById("progressModal")
            );
            if (modal) {
              modal.close();
            }
            // Clear the session and reload
            fetch(`/events/${eventId}/clear_processing_session`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": document
                  .querySelector('meta[name="csrf-token"]')
                  .getAttribute("content"),
              },
            })
              .then(() => {
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              })
              .catch(() => {
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              });
          }, 2000);
        }
      })
      .catch(() => {
        progressText.textContent = "Erro ao verificar progresso...";
      });
  }

  updateProgress();
};
